module.exports = __webpack_public_path__ + "img/45-image-2@2x.98f974ff.png";